export class Context
{
 id:number;
 entityName:string;
 triageStatus:boolean;
}